import { SPIScorecard } from "@/components/spi/SPIScorecard";
import type { SPIResult } from "@/types";

interface PublicScorecardViewProps {
  payload: SPIResult;
}

export function PublicScorecardView({ payload }: PublicScorecardViewProps) {
  return (
    <SPIScorecard
      result={payload}
      onBack={() => undefined}
      hideBackButton
      hideProductInfo={false}
      isPublic
      variant="product-tab"
    />
  );
}
